import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useStore } from '../context/StoreContext';
import { Icons } from '../components/Icons';
import { trackWhatsApp } from '../utils/tracking';
import './Contact.css';

export default function Contact() {
  const { waNum, openWA } = useStore();
  const [form, setForm] = useState({ name:'', phone:'', looking:'', message:'' });
  const [sent, setSent] = useState(false);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSend = () => {
    trackWhatsApp('contact_form');
    const txt = `Assalam o Alaikum!\n\nName: ${form.name||'N/A'}\nPhone: ${form.phone||'N/A'}\nLooking for: ${form.looking||'N/A'}\n\nMessage: ${form.message||'N/A'}`;
    window.open('https://wa.me/' + waNum + '?text=' + encodeURIComponent(txt), '_blank');
    setSent(true);
    setTimeout(() => setSent(false), 4000);
  };

  return (
    <div className="contact-page">
      <Helmet>
        <title>Contact &amp; Shop Location | Artificial Jewellery Shop in Daska, Sialkot</title>
        <meta
          name="description"
          content="Contact our artificial jewellery shop — Shop# 23, Touseef Market, Daska, Sialkot, Pakistan. WhatsApp orders and nationwide delivery across Pakistan."
        />
        <link rel="canonical" href="https://cityshopingcenter.com/contact" />
      </Helmet>

      <div className="page-header" data-echo="CONTACT">
        <h1>CONTACT OUR JEWELLERY SHOP</h1>
        <p>WhatsApp orders &amp; nationwide delivery — Daska, Sialkot, Pakistan</p>
      </div>

      <div className="contact-layout">
        {/* Info */}
        <div className="contact-info" data-reveal="left">
          <h3>GET IN TOUCH</h3>
          {[
            [Icons.pin(), 'Location', 'City Shopping Center\nShop# 23, Touseef Market, Daska, Pakistan'],
            [Icons.whatsapp(), 'WhatsApp', '+' + waNum],
            [Icons.clock(), 'Hours', 'Mon–Sat: 10am–9pm\nSunday: 12pm–8pm'],
          ].map(([ico, h, t], i) => (
            <div key={i} className="contact-info-row">
              <div className="contact-info-icon">{ico}</div>
              <div>
                <h4>{h}</h4>
                <p style={{ whiteSpace: 'pre-line' }}>{t}</p>
              </div>
            </div>
          ))}
          <button className="btn-primary" onClick={openWA} style={{width:'100%',padding:'14px',marginTop:'1rem',display:'flex',alignItems:'center',justifyContent:'center',gap:'10px',borderRadius:'10px'}}>
            {Icons.whatsapp(16)} WhatsApp Us Now
          </button>
        </div>

        {/* Form */}
        <div className="contact-form-box" data-reveal="right">
          <h3>SEND A MESSAGE</h3>
          {sent && <div className="msg-success">{Icons.check()} Sent! We'll reply on WhatsApp soon.</div>}
          <div className="form-group">
            <label>Your Name</label>
            <input className="form-input" value={form.name} onChange={set('name')} placeholder="Zeeshan Abid" />
          </div>
          <div className="form-group">
            <label>Phone / WhatsApp</label>
            <input className="form-input" value={form.phone} onChange={set('phone')} placeholder="+92 311 6401000" type="tel" />
          </div>
          <div className="form-group">
            <label>Looking For</label>
            <select className="form-select" value={form.looking} onChange={set('looking')}>
              <option value="">— Select —</option>
              {['Rings','Necklaces','Earrings','Bracelets','Bridal Set','Custom / Other'].map(o => (
                <option key={o}>{o}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea className="form-textarea" value={form.message} onChange={set('message')} placeholder="Tell us what you're looking for..." />
          </div>
          <button className="btn-primary" onClick={handleSend} style={{width:'100%',padding:'14px',borderRadius:'10px'}}>
            Send via WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
}
